import { ApiService } from '../../../types/api';
import type { ShippingMethodApiBase, ShippingMethodApiResponse } from '../types/shipping-method';
import { ShippingMethodApi, type ShippingMethodApiContract } from './shipping-method.api';

export interface ShippingMethodsApiContract {
  shippingMethod(id: string): ShippingMethodApiContract;

  list(): Promise<ShippingMethodApiResponse[]>;
  create(shippingMethod: ShippingMethodApiBase): Promise<ShippingMethodApiResponse>;
}

declare module '../../../context/page-context' {
  interface Apis {
    shippingMethods: ShippingMethodsApiContract;
  }
}

/**
 * A service to interact with shipping methods via the SparkLayer API.
 */
export class ShippingMethodsApi extends ApiService implements ShippingMethodsApiContract {
  public shippingMethod(id: string): ShippingMethodApiContract {
    return new ShippingMethodApi(this.api, id);
  }

  public list(): Promise<ShippingMethodApiResponse[]> {
    return this.api.proxy<ShippingMethodApiResponse[]>({
      method: 'GET',
      path: '/v1/shipping-methods',
    });
  }

  public create(payload: ShippingMethodApiBase): Promise<ShippingMethodApiResponse> {
    return this.api.proxy<ShippingMethodApiResponse>({
      method: 'POST',
      path: '/v1/shipping-methods',
      payload,
    });
  }
}
